/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import { componentDebug } from '../../core/debug';

import paginationStyle from 'assets/jss/material-dashboard-pro-react/components/paginationStyle.jsx';
import I18n from '../Translate/I18n';
import LeftArrowButton from '../Buttons/LeftArrowButton';
import RightArrowButton from '../Buttons/RightArrowButton';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

function Pagination({ ...props }) {
    const { classes, pages, color, goToPage, paddingTop, totalItems, fromPage, toPage, currentPage, totalPage, goToLastPage } = props;

    let beforeButton = null;
    let afterButton = null;
    if (currentPage > parseInt(pages[0].text)) {
        beforeButton = <LeftArrowButton callback={() => pages[0].onClick(pages[0].url)} callbackParam={{}} />;
    } else {
        beforeButton = <LeftArrowButton disabled callback={() => pages[0].onClick(pages[0].url)} callbackParam={{}} />;
    }

    if (currentPage < parseInt(pages[1].text)) {
        afterButton = <RightArrowButton callback={() => pages[1].onClick(pages[1].url)} callbackParam={{}} />;
    } else {
        afterButton = <RightArrowButton disabled callback={() => prop.onClick(prop.url)} callbackParam={{}} />;
    }
    return (
        <React.Fragment>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: 10 }}>{beforeButton}</div>
                {goToPage && (
                    <React.Fragment key={'goToPage'}>
                        {goToPage} <I18n trans={'general:common.from_page'} />
                        <Button
                            disabled={currentPage === totalPage}
                            variant={'text'}
                            disableRipple
                            onClick={goToLastPage}
                            className={classes.lastPage}
                        >
                            {totalPage}
                        </Button>
                    </React.Fragment>
                )}
                {afterButton}
            </div>
            {totalItems && fromPage && toPage && (
                <ul className={classes.pagination} style={{ paddingTop: "paddingTop: '0.4em'", display: 'block', margin: '0px 10px' }}>
                    <li className={classes.paginationItem}>
                        <I18n
                            trans="general:common.view_page_from_to_all"
                            valueObject={{ fromPage: fromPage, toPage: toPage, totalItems: totalItems }}
                        />
                    </li>
                </ul>
            )}
        </React.Fragment>
    );
}

Pagination.defaultProps = {
    color: 'primary',
};

Pagination.propTypes = {
    classes: PropTypes.object.isRequired,
    pages: PropTypes.arrayOf(
        PropTypes.shape({
            active: PropTypes.bool,
            disabled: PropTypes.bool,
            text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            onClick: PropTypes.func,
            url: PropTypes.string,
        })
    ).isRequired,
    goToPage: PropTypes.object,
    currentPage: PropTypes.oneOfType([PropTypes.number, null]),
    totalPage: PropTypes.number,
    goToLastPage: PropTypes.func,
    color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
};

export default withStyles(oplAppStyle)(Pagination);
